import { styled, css } from 'styled-components'

import { variables } from 'core/styles'

import SearchLink from 'admin/components/Search/SearchLink'

const StyledCard = styled.div`
  position: relative;
`

const StyledLink = styled(SearchLink)`
  display: block;
  border-radius: 4px;
  cursor: ${(p) => (p.disabled ? 'default' : 'pointer')};
  padding: 8px;
  text-decoration: none;
  color: ${(p) => p.theme.text};

  &:focus-visible,
  &:hover:not([disabled]) {
    background-color: ${variables.colorBlack10};
  }

  ${(p) =>
    p.isSelected &&
    css`
      background-color: ${variables.colorBlack10};
    `}

  &[disabled] {
    pointer-events: none;
  }
`

const Title = styled.div`
  opacity: ${(p) => (p.disabled ? 0.5 : 1)};
  color: ${(p) => p.color || (p.isLink ? p.theme.linkText : p.theme.text)};
  font-size: 13px;
  font-weight: bold;
`

const Subtitle = styled.div`
  padding-top: 4px;
  color: ${(p) => p.theme.mutedText};
  font-size: 11px;
`

const Note = styled.div`
  padding-top: 4px;
  color: ${(p) => p.theme.mutedText};
  font-size: 11px;
`

const DisplayCard = (props) => {
  const { title, subtitle, note, color, to, disabled, isSelected, ...rest } = props

  return (
    <StyledCard>
      <StyledLink to={to || '#'} {...rest} disabled={disabled} isSelected={isSelected}>
        <Title color={color} disabled={disabled} isLink={!!to}>
          {title}
        </Title>
        {subtitle && <Subtitle>{subtitle}</Subtitle>}
        {note && <Note>{note}</Note>}
      </StyledLink>
    </StyledCard>
  )
}

export default DisplayCard
